let code = 'pim';
let codeAPI = 'pim';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};